// Keep the public array shape used by filters, dropdowns and job cards.
export const createPostList = (list = [], flags = {}) => Object.assign([...list], {
  isLoaded: false,
  isDataOutdated: false,
  isRefreshing: false,
  hasLoadError: false,
  invalidationVersion: 0,
  requestId: 0,
  loadedKey: null
}, flags);

export const patchPostList = (list, flags) => Object.assign([...list], list, flags);

export const resetPostListScope = (list) => createPostList([], {
  isDataOutdated: true,
  isRefreshing: Boolean(list.isRefreshing),
  requestId: list.requestId || 0,
  invalidationVersion: (list.invalidationVersion || 0) + 1
});
